import React from "react";

export default function Calendar({ className }) {
  return (
    <svg width="100%" height="100%" viewBox="0 0 41 41" className={className}>
      <circle id="Ellipse_39" cx="20.5" cy="20.5" r="20.5" fill="#e9e7de" />
      <path
        id="Path_540"
        d="M19,4H18V3a1,1,0,0,0-2,0V4H8V3A.945.945,0,0,0,7,2,.945.945,0,0,0,6,3V4H5A2.946,2.946,0,0,0,2,7V8H22V7A2.946,2.946,0,0,0,19,4ZM2,19a2.946,2.946,0,0,0,3,3H19a2.946,2.946,0,0,0,3-3V10H2Zm15-7a1,1,0,1,1-1,1A.945.945,0,0,1,17,12Zm0,4a1,1,0,1,1-1,1A.945.945,0,0,1,17,16Zm-5-4a1,1,0,1,1-1,1A.945.945,0,0,1,12,12Zm0,4a1,1,0,1,1-1,1A.945.945,0,0,1,12,16ZM7,12a1,1,0,0,1,0,2,1,1,0,0,1,0-2Zm0,4a1,1,0,0,1,0,2,1,1,0,0,1,0-2Z"
        transform="translate(9 8)"
        fill="#555"
        opacity="0.5"
      />
    </svg>
  );
}
